export default __webpack_public_path__ + "static/media/all-temples-dwaraka-tirumala-card-img.d30af042.png";